module.exports = __webpack_public_path__ + "static/media/page-6.19c2e99f.png";